module.exports = __webpack_public_path__ + "static/media/logout-white.43bde43d.svg";